import {
  bulkCreateMessages as publicBulkCreateMessages,
  listMessages as publicListMessages,
  mediaAttachmentUploadUrl as publicMediaAttachmentUploadUrl,
  bulkGetByInboxMessages as publicBulkGetByInboxMessages,
} from './innovation-widget-v1-message-messages.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const bulkCreateMessages: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateMessages> &
    typeof publicBulkCreateMessages
> = /*#__PURE__*/ createRESTModule(publicBulkCreateMessages);
export const listMessages: MaybeContext<
  BuildRESTFunction<typeof publicListMessages> & typeof publicListMessages
> = /*#__PURE__*/ createRESTModule(publicListMessages);
export const mediaAttachmentUploadUrl: MaybeContext<
  BuildRESTFunction<typeof publicMediaAttachmentUploadUrl> &
    typeof publicMediaAttachmentUploadUrl
> = /*#__PURE__*/ createRESTModule(publicMediaAttachmentUploadUrl);
export const bulkGetByInboxMessages: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetByInboxMessages> &
    typeof publicBulkGetByInboxMessages
> = /*#__PURE__*/ createRESTModule(publicBulkGetByInboxMessages);

export {
  Sender,
  MessageType,
  ChatHandler,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  AllocationResultType,
  WebhookIdentityType,
} from './innovation-widget-v1-message-messages.universal.js';
export {
  Message,
  Body,
  BulkCreateMessagesRequest,
  BulkCreateMessagesResponse,
  ListMessagesRequest,
  CursorPaging,
  ListMessagesResponse,
  PagingMetadataV2,
  Cursors,
  MediaAttachmentUploadUrlRequest,
  MediaAttachmentUploadUrlResponse,
  BulkGetByInboxMessagesRequest,
  BulkGetByInboxMessagesResponse,
  ItemMetadata,
  ApplicationError,
  BulkGetByInboxMessagesResult,
  BulkActionMetadata,
  ScheduleCreateInsightsRequest,
  ScheduleCreateInsightsResponse,
  CancelCreateInsightsRequest,
  CancelCreateInsightsResponse,
  SetupRequest,
  SetupResponse,
  TeardownRequest,
  TeardownResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  CommunicationsChannelsMessageReceived,
  VisitorMappedToContact,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BulkCreateMessagesOptions,
  ListMessagesOptions,
  MediaAttachmentUploadUrlOptions,
  BulkGetByInboxMessagesOptions,
} from './innovation-widget-v1-message-messages.universal.js';
export {
  SenderWithLiterals,
  MessageTypeWithLiterals,
  ChatHandlerWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  AllocationResultTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './innovation-widget-v1-message-messages.universal.js';
